import React from 'react';
import PropTypes from 'prop-types';

import DefaultTooltipContent from 'recharts/lib/component/DefaultTooltipContent';

const propTypes = {
    payload: PropTypes.array,
};

const defaultProps = {
    payload: [],
};

const GraphTotalTooltip = (props) => {
    const { payload } = props;
    if (payload && payload[0]) {
        const newPayload = [
            {
                name: 'Total',
                value: payload.reduce((acc, data) => acc + parseFloat(data.value, 10), 0),
            },
            ...payload.reverse(),
        ];

        return <DefaultTooltipContent {...props} payload={newPayload} />;
    }

    return <DefaultTooltipContent {...props} />;
};

GraphTotalTooltip.propTypes = propTypes;
GraphTotalTooltip.defaultProps = defaultProps;

export default GraphTotalTooltip;
